import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-approvedcontract',
  templateUrl: './approvedcontract.component.html',
  styleUrls: ['./approvedcontract.component.css']
})
export class ApprovedcontractComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
